/**
 * webpack entry point for the disclosure page iframe bundle
 */

import "reflect-metadata";
import './calcbenchApp/footnote/factHover/factHoverTooltip';
import './calcbenchApp/footnote/disclosureIFrame/iframeSetup';
import './calcbenchApp/footnote/disclosureIFrame/iFrame.scss';
import 'iframe-resizer/js/iframeResizer.contentWindow'

(<any>window).$ = (<any>window).jQuery = require('jquery');